<template>
  <div class="file-manager-application">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-area-wrapper">
      <div class="content-right">
        <div class="content-wrapper">
          <div class="content-header row" />
          <div class="content-body">
            <!-- overlay container -->
            <div class="body-content-overlay" />
            <RouterView />
          </div>
        </div>
      </div>
    </div>
    <NewEntityModal />
  </div>
</template>

<script>
import NewEntityModal from './components/NewEntityModal'

export default {
  components: {
    NewEntityModal
  },
  computed: {},
  mounted: async function () {}
}
</script>

<style>
.vault-label {
  margin-left: 15px;
}
.content-area-wrapper {
  height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0.3rem)) !important;
}
.content-right {
  width: 100% !important;
}
</style>
